/**
 * VideoSubtitleModalController is a class that controls the behavior of a modal
 * for managing video subtitles in an invigilator menu. It interacts with AngularJS services
 * to handle user preferences and modal interactions.
 * 
 * @class
 * @param {Object} $scope - The AngularJS scope object.
 * @param {Object} $uibModalInstance - The instance of the modal dialog.
 * @param {Object} taskCountdownService - Service for managing task countdowns.
 * @param {Object} $eventLog - Service for logging events.
 * @param {Object} iaaPreferences - Object containing user preferences.
 * @param {Object} IAAPreferencesService - Service for managing user preferences.
 */
export default class VideoSubtitleModalController {
    constructor($scope, $uibModalInstance, taskCountdownService, $eventLog, iaaPreferences, IAAPreferencesService) {
        /**
         * The AngularJS scope object.
         * @type {Object}
         */
        this.$scope = $scope;

        /**
         * The instance of the modal dialog.
         * @type {Object}
         */
        this.$uibModalInstance = $uibModalInstance;

        /**
         * Service for managing task countdowns.
         * @type {Object}
         */
        this.taskCountdownService = taskCountdownService;

        /**
         * Service for logging events.
         * @type {Object}
         */
        this.$eventLog = $eventLog;

        /**
         * Object containing user preferences.
         * @type {Object}
         */
        this.iaaPreferences = iaaPreferences;

        /**
         * Service for managing user preferences.
         * @type {Object}
         */
        this.IAAPreferencesService = IAAPreferencesService;

        /**
         * The key for the video subtitle auto-enable preference.
         * @type {string}
         */
        this.iaaKey = 'videoSubtitleAutoEnable';

        // Set the event type reason if it is provided.
        if (_selectedEventTypeReason) {
            this.$scope.eventTypeReason = _selectedEventTypeReason;
        }

        // Initialize the video subtitle auto-enable preference in the scope.
        this.$scope.videoSubtitleAutoEnable = this.iaaPreferences[this.iaaKey];

        // Bind the onConfirm method to the current instance.
        this.$scope.onConfirm = this.onConfirm.bind(this);
    }

    /**
     * Handles the confirmation action when the user confirms the modal.
     * 
     * @method
     */
    onConfirm() {
        // Set the confirm flag on the modal instance.
        this.$uibModalInstance.confirm = true;

        // If an event explanation is provided, set it using the preferences service.
        if (this.$scope.eventExplanation) {
            this.IAAPreferencesService.setEventExplanation(this.iaaKey, this.$scope.eventExplanation);
        }

        // Toggle the video subtitle auto-enable preference.
        this.iaaPreferences[this.iaaKey] = !this.iaaPreferences[this.iaaKey];

        // Close the modal.
        this.$uibModalInstance.close();
    }
}